import { render, staticRenderFns } from "./AiCreate.vue?vue&type=template&id=41a22871&scoped=true"
import script from "./AiCreate.vue?vue&type=script&lang=js"
export * from "./AiCreate.vue?vue&type=script&lang=js"
import style0 from "./AiCreate.vue?vue&type=style&index=0&id=41a22871&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a22871",
  null
  
)

export default component.exports